import { Box, Span } from '@bpba/ui-components';
import { fixedTermStatus, fixedTermStatusColor, fixedTermTooltip } from '../constants/data';
import { IFixedTermItem } from '../types/IFixedTermItem';
import { renderAmount } from './RenderAmount';
import { renderDate } from './RenderDate';
import { renderRate } from './RenderRate';
import styled from 'styled-components';
import { PanelDivisor } from '../components/shared/PanelDivisor';
import { AceptationButton } from './AceptationButton';
import { StyledBox } from '../components/shared/StyledBox';
import { renderTime } from './RenderTime';
import { InfoTooltip } from '../components/shared/InfoTooltip';

type PlazoFijoItemProps = {
  data: IFixedTermItem;
};

export const PlazoFijoItem = ({ data }: PlazoFijoItemProps) => {
  const tooltipText = fixedTermTooltip(data.status);
  return (
    <StyledPanelDivisor flexDirection={['column', null, 'row']} display={'flex'} py={'16px'} fontWeight={500} mb={'16px'}>
      <StyledBox gap="12px" flexDirection={'column'} lineHeight={'25px'}>
        <StyledBox fontSize={'16px'} gap="8px" whiteSpace="nowrap" display={['flex', null, 'none']} flexDirection={'row'} color={'primary.0'} fontWeight={600}>
          <Span color={fixedTermStatusColor(data.status!)}>{fixedTermStatus(data.status!)}</Span>
          {InfoTooltip(tooltipText, [12, 18, 20], 0, 0, false)?.({})}
        </StyledBox>
        <StyledBox gap="0px" flexDirection={'column'} fontSize={'16px'} whiteSpace="nowrap">
          <Box fontWeight={600}>
            {renderDate(data.createdDate)} - {renderDate(data.expiredDate)} ({data.term && data.term} días)
          </Box>
          <Box fontSize={'12px'} lineHeight={'16px'}>
            Hora {renderTime(data.createdDate)}
          </Box>
        </StyledBox>
        <StyledBox gap="8px" whiteSpace="nowrap" flexDirection={'row'} fontSize={'16px'}>
          <StyledBox gap="0px" whiteSpace="nowrap" flexDirection={'column-reverse'} width={'fit-content'} alignItems={'center'}>
            <Span fontSize={'12px'}>(capital)</Span>
            <Span fontWeight={600}>{renderAmount(data.amount)}</Span>
          </StyledBox>
          <StyledBox gap="2px" whiteSpace="nowrap" flexDirection={'column-reverse'} width={'fit-content'} alignItems={'center'}>
            <Span>&nbsp;</Span>
            <Span fontWeight={600}>+</Span>
          </StyledBox>
          <StyledBox gap="2px" whiteSpace="nowrap" flexDirection={'column-reverse'} width={'fit-content'} alignItems={'center'}>
            <Span fontSize={'12px'}>(interés)</Span>
            <Span fontWeight={600}>{renderAmount(data.interest)}</Span>
          </StyledBox>
          <StyledBox gap="2px" whiteSpace="nowrap" flexDirection={'column-reverse'} width={'fit-content'} alignItems={'center'}>
            <Span>&nbsp;</Span>
            <Span fontWeight={600}>=</Span>
          </StyledBox>
          <StyledBox gap="2px" whiteSpace="nowrap" flexDirection={'column-reverse'} width={'fit-content'} alignItems={'center'}>
            <Span fontSize={'12px'}>(total)</Span>
            <Span fontWeight={600}>{renderAmount(data.finalAmount)}</Span>
          </StyledBox>
        </StyledBox>
      </StyledBox>
      <StyledBox gap="12px" flexDirection={'column'} width={'fit-content'} alignItems={['start', null, 'end']}>
        <StyledBox
          gap="8px"
          whiteSpace="nowrap"
          display={['none', null, 'flex']}
          flexDirection={'row'}
          fontSize={'16px'}
          fontWeight={600}
          justifyContent={['flex-start', null, 'flex-end']}
        >
          <Span color={fixedTermStatusColor(data.status!)}>{fixedTermStatus(data.status!)}</Span>
          {InfoTooltip(tooltipText, [12, 18, 20], 0, 0, false)?.({})}
        </StyledBox>
        <StyledBox gap="8px" whiteSpace="nowrap" flexDirection={'row'} justifyContent={['flex-start', null, 'flex-end']}>
          <Span>Certificado</Span>
          <Span> {data.certificate || '-'}</Span>
        </StyledBox>
        <StyledBox gap="8px" whiteSpace="nowrap" flexDirection={'row'} justifyContent={['flex-start', null, 'flex-end']}>
          <Span>CBU</Span>
          <Span>{data.uniformBankKey}</Span>
        </StyledBox>
        <StyledBox gap="8px" whiteSpace="nowrap" flexDirection={'row'} justifyContent={['flex-start', null, 'flex-end']}>
          <Span>TNA</Span>
          <Span>{renderRate(data.tna)}</Span>
        </StyledBox>
        <Box width={['fit-content']} display={'contents'}>
          <AceptationButton data={data} />
        </Box>
      </StyledBox>
    </StyledPanelDivisor>
  );
};

const StyledPanelDivisor = styled(PanelDivisor)({
  gap: '32px',
});
